<template>
    <div class="sidebar-global">
        <div class="container">
            <div class="header-sidebar d-flex">
                <div class="hamburger hamburger-menu" @click="hamburgerClick()" :class="{hamburgerIsActive: isNavOpen}">
                    <span class="line"></span>
                    <span class="line"></span>
                    <span class="line"></span>
                </div>
                <div class="logo" :class="{logoWrapperActive: isNavOpen}">
                    <router-link class="menu-item" :to="{ name: 'Home' }" data-text="Home">
                        <span>
                            J<span class="colapsed">
                                <span :class="{logoIsActive: isNavOpen}">u</span>
                                <span :class="{logoIsActive: isNavOpen}">n</span>
                                <span :class="{logoIsActive: isNavOpen}">g</span>
                                <span :class="{logoIsActive: isNavOpen}">R</span>
                                <span :class="{logoIsActive: isNavOpen}">a</span>
                                <span :class="{logoIsActive: isNavOpen}">m</span>
                                <span :class="{logoIsActive: isNavOpen}">a</span>
                            </span>.
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-menu" :class="{'sidebar-menu-active': isNavOpen}">
            <div class="menu-content">
                <div class="menu-item-wrapper">
                    <router-link class="menu-item"
                    :class="{'active' : currentRouteName == 'Home'}" 
                    @click.native="isNavOpen = false" :to="{ name: 'Home' }" data-text="Home">
                        Home
                    </router-link>
                </div>
                <div class="menu-item-wrapper">
                    <router-link class="menu-item"
                    :class="{'active' : currentRouteName == 'Profile'}" 
                    @click.native="isNavOpen = false" :to="{ name: 'Profile' }" data-text="Profile">
                        Profile
                    </router-link>
                </div>
                <div class="menu-item-wrapper">
                    <router-link class="menu-item"
                    :class="{'active' : currentRouteName == 'Products' || currentRouteName == 'ProductDetail'}" 
                    @click.native="isNavOpen = false" :to="{ name: 'Products' }" data-text="Products">
                        Products
                    </router-link>
                </div>
                <div class="menu-item-wrapper">
                    <router-link class="menu-item"
                    :class="{'active' : currentRouteName == 'Portfolios' || currentRouteName == 'PortfolioDetail'}" 
                    @click.native="isNavOpen = false" :to="{ name: 'Portfolios' }" data-text="Portfolios">
                        Portfolios
                    </router-link>
                </div>
                <div class="menu-item-wrapper">
                    <a class="menu-item"
                    :class="{'active' : currentRouteName == 'Blogs' || currentRouteName == 'BlogDetail'}" 
                    href="https://medium.com/@jungrama.id" target="_blank" data-text="Blogs">
                        Blogs
                    </a>
                </div>
                <div class="menu-item-wrapper">
                    <router-link class="menu-item"
                    :class="{'active' : currentRouteName == 'Contact'}" 
                    @click.native="isNavOpen = false" :to="{ name: 'Contact' }" data-text="Contact">
                        Contact
                    </router-link>
                </div>

                <div class="oranment-sidebar">
                    <img src="@/assets/images/ornament-block-pattern.svg" alt="">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isNavOpen: false,
            isChangePage: false,
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        hamburgerClick() {
            this.isNavOpen = !this.isNavOpen;
            this.isChangePage = false;
        },
        nav() {
            console.log(1);
            
        }
    },
}
</script>